import React from 'react';
import * as pt from 'prop-types';
import createReactClass from 'create-react-class';
import update from 'react-addons-update';
import _ from 'underscore';

import MetadataActions from '../../flux/MetadataActions.js';
import NotifcationActions from '../../../common/flux/NotificationActions.js';
import WorkspaceActions from '../../../common/flux/WorkspaceActions.js';

import Loader from '../../../common/components/notifications/Loader';
import Categories from './Categories';
import MetadataFilter from '../MetadataFilter';
import CreateCategoryModal from './modals/CreateCategoryModal';
import RestrictedComponent from '../../../lib/components/form/RestrictedComponent.js';
import schema from '../../../routes/permissions/schema.js';

var CategoryListing = createReactClass({

    getInitialState: function () {
        return {
            createModal: false,
            validators: [],
            term: '',
            isTyping: false
        };
    },

    termChanged: function (term) {
        this.setState({
            term: term,
            isTyping: false
        });
    },

    handleTypingStarted: function () {
        this.setState({
            isTyping: true
        });
    },

    toggleCreateModal: function () {
        this.setState({
            createModal: !this.state.createModal
        });
    },

    save: function (category) {
        if (this.valid(category)) {
            // Object => Boolean
            if (!!category.parentCategoryID) {
                category.childOf = category.parentCategoryID.value;
                delete category.parentCategoryID;
            }
            this.props.actions.add(category, function () {
                this.toggleCreateModal();
            }.bind(this));
        }
    },

    valid: function (category) {
        var failed = [], messages = [];

        if (category.categoryName === '') {
            failed.push('categoryName');
            messages.push('Category Name is Required');
        }

        if (failed.length) {
            this.setState({
                validators: failed
            });

            NotifcationActions.notify({
                type: 'warning',
                messages: messages
            });

            return false;
        }

        return true;
    },

    render: function () {
        return this.props.isResolving ?
            <Loader message='Fetching Categories'/> :
            this.renderCategories()
        ;
    },

    renderCategories: function () {

        var listing;

        if (this.state.isTyping) {
            listing = <Loader message='Filtering'/>;
        } else if (!this.props.data.length) {
            listing = (
                <div className="alert alert-info">
                    <h4>No Categories have been created yet</h4>
                    <p>
                        <RestrictedComponent permissionCheck={schema.MANAGE_CLIENT_CATEGORIES.CREATE}>
                            <a href="#" onClick={this.toggleCreateModal}><em>Create One Now &hellip;</em></a>
                        </RestrictedComponent>
                    </p>
                </div>
            );
        } else {
            listing = <Categories {...this.props}
                categories={this.props.data}
                nested={this.props.nested}
                term={this.state.term.toLowerCase()}
            />;
        }

        var filter;

        switch (this.props.mode) {
            case 'event':
            case 'select-one':
                filter = (
                    <div className="callout clearfix">
                        <MetadataFilter termChanged={this.termChanged}
                        isTyping={this.handleTypingStarted}/>
                    </div>
                );
                break;

            case 'manage':
                filter = (
                    <div className="callout clearfix">
                        <div className="col-md-8">
                            <MetadataFilter
                                termChanged={this.termChanged}
                                isTyping={this.handleTypingStarted}
                            />
                        </div>
                        <div className="col-md-4 text-right">
                            <RestrictedComponent permissionCheck={schema.MANAGE_CLIENT_CATEGORIES.CREATE}>
                                <button className="btn btn-primary" onClick={this.toggleCreateModal}>
                                    <i className="fa fa-plus"/> Create Category
                                </button>
                            </RestrictedComponent>
                        </div>
                    </div>
                );
                break;
        }

        return (
            <div className="category-listing">

                {filter}

                <hr/>

                <div className="well">
                    {listing}
                </div>

                {this.renderModals()}
            </div>
        );
    },

    renderModals: function () {
        if (this.state.createModal) {
            var categories = [];
            this.props.data.map(function (category) {
                if (category.parentCategoryID === null) {
                    categories.push(
                        { value: category.categoryID, label: category.categoryName }
                    );
                }
            });
            return (<CreateCategoryModal
                save={this.save}
                categories={categories}
                createModal={this.state.createModal}
                toggleCreateModal={this.toggleCreateModal}
            />);
        }
    }
});

export default CategoryListing;
